type Store = {
  pageType: PageType
  pageTypeId: string
  pageHeight: number
}

export default () =>
  useState<Store>('store', () => ({
    pageType: '',
    pageTypeId: '',
    pageHeight: 0,
  }))
